<template>
  <div class="lazy-container">
    <slot></slot>
  </div>
</template>

<script>
  import 'intersection-observer';

  export default {
	name: "LazyContainer",
	components: {},
	props: {
	  disabled: Boolean
	},
	data() {
	  return {
		children: []
	  };
	},
	created() {
	  if (this.disabled) return;
	  this.debouncedObserver = this.$utils.debounce(this.observer);
	},
	mounted() {
	  if (this.disabled) return;
	  this.$nextTick(() => {
		this.createObserver();
	  });
	},
	methods: {
	  createObserver() {
		this.iObserver = new IntersectionObserver(entries => {
		  const onShow = entries.find(it => it.isIntersecting && it.boundingClientRect.top > (it.rootBounds.height - 10));
		  const {hiddenEntries, visibleEntries} = entries.reduce((p, it) => {
			it.isIntersecting ? p.visibleEntries.push(it.target) : p.hiddenEntries.push(it.target);
			return p;
		  }, {
			visibleEntries: [],
			hiddenEntries: [],
		  });

		  this.children.forEach((vm, index) => {
			if (visibleEntries.includes(vm.$el)) {
			  vm.onVisible && vm.onVisible();
			}
			if (hiddenEntries.includes(vm.$el)) {
			  vm.onHidden && vm.onHidden();
			}
		  });
		});
	  },
	  observer(el) {
		this.children.forEach(vm => {
		  this.iObserver.unobserve(vm.$el);
		  this.iObserver.observe(vm.$el);
		});
	  }
	},
	computed: {},
	watch: {
	  children() {
		if (this.disabled) return;
		this.debouncedObserver && this.debouncedObserver();
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .lazy-container {
  }
</style>
